"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable max-len */
var react_1 = __importDefault(require("react"));
var SearchSm = function (_a) {
    var size = _a.size, title = _a.title, color = _a.color, svgProps = __rest(_a, ["size", "title", "color"]);
    return (react_1.default.createElement("svg", __assign({ stroke: "currentcolor", fill: "currentColor", strokeWidth: "0" }, svgProps, { width: size || '1rem', height: size || '1rem', viewBox: "0 0 24 24", style: __assign({ color: color }, svgProps.style), xmlns: "http://www.w3.org/2000/svg" }),
        title && react_1.default.createElement("title", null, title),
        react_1.default.createElement("g", { id: "search-sm" },
            react_1.default.createElement("path", { id: "Icon", d: "M20.2929 21.7071C20.6834 22.0976 21.3166 22.0976 21.7071 21.7071C22.0976 21.3166 22.0976 20.6834 21.7071 20.2929L20.2929 21.7071ZM15.7072 14.2929C15.3167 13.9024 14.6835 13.9024 14.293 14.2929C13.9025 14.6834 13.9025 15.3166 14.293 15.7071L15.7072 14.2929ZM21.7071 20.2929L15.7072 14.2929L14.293 15.7071L20.2929 21.7071L21.7071 20.2929ZM16 10C16 13.3137 13.3137 16 10 16V18C14.4183 18 18 14.4183 18 10H16ZM10 16C6.68629 16 4 13.3137 4 10H2C2 14.4183 5.58172 18 10 18V16ZM4 10C4 6.68629 6.68629 4 10 4V2C5.58172 2 2 5.58172 2 10H4ZM10 4C13.3137 4 16 6.68629 16 10H18C18 5.58172 14.4183 2 10 2V4Z" }))));
};
exports.default = SearchSm;
